import { useId } from "react";
import { GardenGround, SkySvgShell, VIEW_HEIGHT, VIEW_WIDTH } from "@/app/components/weather/backgrounds/shared";

/**
 * CloudyDaySky — soft blue-gray day sky with bright white cloud layers.
 * Full-viewport illustration; garden silhouettes anchor to the bottom edge.
 */
export function CloudyDaySky() {
  const uid = useId().replace(/:/g, "");
  const sky = `${uid}-sky`;
  const haze = `${uid}-haze`;
  const rimtop = `${uid}-rimtop`;

  return (
    <SkySvgShell>
      <defs>
        <linearGradient id={sky} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#8AACCC" />
          <stop offset="35%" stopColor="#A8C4DC" />
          <stop offset="70%" stopColor="#C8DCE8" />
          <stop offset="100%" stopColor="#E0ECF4" />
        </linearGradient>
        <linearGradient id={haze} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#E0ECF4" stopOpacity="0" />
          <stop offset="100%" stopColor="#D8E8F0" stopOpacity="0.9" />
        </linearGradient>
        <linearGradient id={rimtop} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#FFFFFF" stopOpacity="0.5" />
          <stop offset="100%" stopColor="#FFFFFF" stopOpacity="0" />
        </linearGradient>
      </defs>

      <rect width={VIEW_WIDTH} height={VIEW_HEIGHT} fill={`url(#${sky})`} />

      <g fill="#F0F4F8" opacity="0.88">
        <ellipse cx="62" cy="55" rx="72" ry="26" />
        <ellipse cx="28" cy="50" rx="38" ry="20" />
        <ellipse cx="108" cy="50" rx="44" ry="21" />
        <ellipse cx="178" cy="62" rx="58" ry="22" />
        <ellipse cx="148" cy="56" rx="36" ry="18" />
        <ellipse cx="218" cy="57" rx="32" ry="17" />
        <ellipse cx="338" cy="58" rx="64" ry="24" />
        <ellipse cx="304" cy="52" rx="38" ry="19" />
        <ellipse cx="372" cy="53" rx="36" ry="18" />
      </g>

      <g fill="#E8EEF4" opacity="0.92">
        <ellipse cx="80" cy="88" rx="80" ry="30" />
        <ellipse cx="36" cy="82" rx="44" ry="22" />
        <ellipse cx="132" cy="82" rx="52" ry="24" />
        <ellipse cx="220" cy="96" rx="68" ry="27" />
        <ellipse cx="178" cy="88" rx="42" ry="22" />
        <ellipse cx="268" cy="90" rx="40" ry="21" />
        <ellipse cx="340" cy="90" rx="72" ry="28" />
        <ellipse cx="298" cy="83" rx="46" ry="22" />
        <ellipse cx="382" cy="84" rx="38" ry="20" />
      </g>

      <g fill="#FFFFFF" opacity="0.95">
        <ellipse cx="100" cy="122" rx="96" ry="36" />
        <ellipse cx="44" cy="114" rx="54" ry="28" />
        <ellipse cx="162" cy="114" rx="60" ry="28" />
        <ellipse cx="264" cy="118" rx="90" ry="34" />
        <ellipse cx="214" cy="110" rx="52" ry="26" />
        <ellipse cx="320" cy="110" rx="56" ry="26" />
        <ellipse cx="370" cy="128" rx="52" ry="30" />
        <ellipse cx="356" cy="118" rx="36" ry="22" />
        <ellipse cx="388" cy="120" rx="28" ry="18" />
      </g>

      <g opacity="0.6">
        <ellipse cx="92" cy="100" rx="82" ry="8" fill={`url(#${rimtop})`} />
        <ellipse cx="258" cy="97" rx="76" ry="9" fill={`url(#${rimtop})`} />
        <ellipse cx="368" cy="109" rx="46" ry="6" fill={`url(#${rimtop})`} />
      </g>

      <rect x="0" y="200" width={VIEW_WIDTH} height={VIEW_HEIGHT - 200} fill={`url(#${haze})`} />

      <GardenGround fill="#1A2838" />
    </SkySvgShell>
  );
}
